import React from 'react';

type MonitorMockupProps = {
  width: string;
  height: string;
  fill?: string;
  children?: JSX.Element;
};

function MonitorMockup({ width, height, fill, children }: MonitorMockupProps) {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 731.963 652.468'
      xmlSpace='preserve'
    >
      <g>
        <g>
          <g>
            <g>
              <linearGradient
                id='SVGID_1_'
                gradientUnits='userSpaceOnUse'
                x1='366.6074'
                y1='650.9746'
                x2='366.6074'
                y2='612.8587'
              >
                <stop offset='0' style={{ stopColor: '#2C2F31' }} />
                <stop offset='0.0448' style={{ stopColor: '#303234' }} />
                <stop offset='0.2998' style={{ stopColor: '#424242' }} />
                <stop offset='0.3291' style={{ stopColor: '#525252' }} />
                <stop offset='0.4551' style={{ stopColor: '#919191' }} />
                <stop offset='0.5616' style={{ stopColor: '#C0C0BF' }} />
                <stop offset='0.6431' style={{ stopColor: '#DCDCDB' }} />
                <stop offset='0.69' style={{ stopColor: '#E7E7E6' }} />
                <stop offset='0.8354' style={{ stopColor: '#E5E5E4' }} />
                <stop offset='0.8878' style={{ stopColor: '#DEDEDD' }} />
                <stop offset='0.9252' style={{ stopColor: '#D3D3D2' }} />
                <stop offset='0.9554' style={{ stopColor: '#C2C2C1' }} />
                <stop offset='0.9809' style={{ stopColor: '#ACACAC' }} />
                <stop offset='1' style={{ stopColor: '#969696' }} />
              </linearGradient>
              <path
                style={{ fill: 'url(#SVGID_1_)' }}
                d='M438.994,628.309l-0.033-0.146l-72.357,0.073l-72.353-0.073l-0.033,0.146l-154.348,0.15
					v8.641c0,0,0.598,3.277,5.385,3.574h146.314h150.08h146.311c4.791-0.297,5.387-3.574,5.387-3.574v-8.641L438.994,628.309z'
              />

              <linearGradient
                id='SVGID_00000052800688177693833280000000155063039068880296_'
                gradientUnits='userSpaceOnUse'
                x1='366.588'
                y1='507.7112'
                x2='366.588'
                y2='652.4987'
              >
                <stop offset='0' style={{ stopColor: '#2C2F31' }} />
                <stop offset='0.0505' style={{ stopColor: '#717374' }} />
                <stop offset='0.1106' style={{ stopColor: '#BDBEBF' }} />
                <stop offset='0.1535' style={{ stopColor: '#EDEDED' }} />
                <stop offset='0.1749' style={{ stopColor: '#FFFFFF' }} />
                <stop offset='0.2106' style={{ stopColor: '#FAFAFA' }} />
                <stop offset='0.2556' style={{ stopColor: '#EAEBEB' }} />
                <stop offset='0.3057' style={{ stopColor: '#D0D2D2' }} />
                <stop offset='0.3594' style={{ stopColor: '#ACAFAF' }} />
                <stop offset='0.4154' style={{ stopColor: '#7F8283' }} />
                <stop offset='0.4194' style={{ stopColor: '#7B7F80' }} />
                <stop offset='0.4403' style={{ stopColor: '#787B7C' }} />
                <stop offset='0.5256' style={{ stopColor: '#707171' }} />
                <stop offset='0.6234' style={{ stopColor: '#6E6E6E' }} />
                <stop offset='0.8652' style={{ stopColor: '#E7E7E6' }} />
                <stop offset='0.9284' style={{ stopColor: '#E5E5E4' }} />
                <stop offset='0.9512' style={{ stopColor: '#DEDEDD' }} />
                <stop offset='0.9675' style={{ stopColor: '#D3D3D2' }} />
                <stop offset='0.9806' style={{ stopColor: '#C2C2C1' }} />
                <stop offset='0.9917' style={{ stopColor: '#ACACAC' }} />
                <stop offset='1' style={{ stopColor: '#969696' }} />
              </linearGradient>
              <path
                style={{
                  fill: 'url(#SVGID_00000052800688177693833280000000155063039068880296_)',
                }}
                d='M593.307,628.459
					c0.443-5.197-9.385-9.094-9.385-9.094s-90.244-19.494-115.264-29.887c-25.02-10.395-25.91-40.282-25.91-40.282V425.621h-71.607
					h-9.103h-71.604v123.575c0,0-0.893,29.888-25.912,40.282c-25.02,10.393-115.266,29.887-115.266,29.887s-9.834,3.897-9.387,9.094
					c0,0-1.441,3.354,14.346,3.354h207.822h9.103h207.826C594.752,631.813,593.307,628.459,593.307,628.459z'
              />

              <linearGradient
                id='SVGID_00000143578911240348907760000010485495198152490118_'
                gradientUnits='userSpaceOnUse'
                x1='366.5908'
                y1='508.4138'
                x2='366.5908'
                y2='528.4431'
              >
                <stop offset='0' style={{ stopColor: '#2C2F31' }} />
                <stop offset='0.1538' style={{ stopColor: '#717374' }} />
                <stop offset='0.3365' style={{ stopColor: '#BDBEBF' }} />
                <stop offset='0.4673' style={{ stopColor: '#EDEDED' }} />
                <stop offset='0.5322' style={{ stopColor: '#FFFFFF' }} />
                <stop offset='0.999' style={{ stopColor: '#FFFFFF' }} />
              </linearGradient>

              <rect
                x='290.434'
                y='425.621'
                style={{
                  fill: 'url(#SVGID_00000143578911240348907760000010485495198152490118_)',
                }}
                width='152.314'
                height='102.869'
              />
            </g>

            <linearGradient
              id='SVGID_00000044173147435781623260000016967139298802741663_'
              gradientUnits='userSpaceOnUse'
              x1='366.5879'
              y1='-284.054'
              x2='366.5879'
              y2='873.1351'
            >
              <stop offset='0' style={{ stopColor: '#2C2F31' }} />
              <stop offset='0.049' style={{ stopColor: '#36393A' }} />
              <stop offset='0.1316' style={{ stopColor: '#505254' }} />
              <stop offset='0.2377' style={{ stopColor: '#7B7D7E' }} />
              <stop offset='0.3631' style={{ stopColor: '#B6B7B8' }} />
              <stop offset='0.5002' style={{ stopColor: '#FFFFFF' }} />
              <stop offset='0.5706' style={{ stopColor: '#C9C9C9' }} />
              <stop offset='0.6575' style={{ stopColor: '#8C8C8C' }} />
              <stop offset='0.7411' style={{ stopColor: '#5A5A5A' }} />
              <stop offset='0.8194' style={{ stopColor: '#333333' }} />
              <stop offset='0.8909' style={{ stopColor: '#171717' }} />
              <stop offset='0.9534' style={{ stopColor: '#060606' }} />
              <stop offset='1' style={{ stopColor: '#000000' }} />
            </linearGradient>
            <path
              style={{
                fill: 'url(#SVGID_00000044173147435781623260000016967139298802741663_)',
              }}
              d='M703.162,10.066H446.734H286.441H30.014
				c-19.93,0-19.74,19.515-19.74,19.515v75.747v311.836v75.746c0,0-0.189,19.509,19.74,19.509h256.428h160.293h256.428
				c19.93,0,19.74-19.509,19.74-19.509v-75.746V105.328V29.581C722.902,29.581,723.092,10.066,703.162,10.066z'
            />

            <linearGradient
              id='SVGID_00000149341300273281158650000011200192764003420573_'
              gradientUnits='userSpaceOnUse'
              x1='366.5879'
              y1='-355.5402'
              x2='366.5879'
              y2='791.103'
            >
              <stop offset='0' style={{ stopColor: '#2C2F31' }} />
              <stop offset='0.049' style={{ stopColor: '#36393A' }} />
              <stop offset='0.1316' style={{ stopColor: '#505254' }} />
              <stop offset='0.2377' style={{ stopColor: '#7B7D7E' }} />
              <stop offset='0.3631' style={{ stopColor: '#B6B7B8' }} />
              <stop offset='0.5002' style={{ stopColor: '#FFFFFF' }} />
              <stop offset='0.5706' style={{ stopColor: '#C9C9C9' }} />
              <stop offset='0.6575' style={{ stopColor: '#8C8C8C' }} />
              <stop offset='0.7411' style={{ stopColor: '#5A5A5A' }} />
              <stop offset='0.8194' style={{ stopColor: '#333333' }} />
              <stop offset='0.8909' style={{ stopColor: '#171717' }} />
              <stop offset='0.9534' style={{ stopColor: '#060606' }} />
              <stop offset='1' style={{ stopColor: '#000000' }} />
            </linearGradient>
            <path
              style={{
                fill: 'url(#SVGID_00000149341300273281158650000011200192764003420573_)',
              }}
              d='M698.197,11.641H445.555h-157.93H34.982
				c-19.637,0-19.451,19.338-19.451,19.338v75.058v308.995v75.054c0,0-0.186,19.33,19.451,19.33h252.643h157.93h252.643
				c19.633,0,19.447-19.33,19.447-19.33v-75.054V106.036V30.979C717.644,30.979,717.83,11.641,698.197,11.641z'
            />
            <path
              style={{ fill: '#FFFFFF' }}
              d='M716.652,404.348V33.65c0,0,0.19-19.176-19.389-19.176H35.914
				c-19.58,0-19.389,19.176-19.389,19.176v370.697H716.652z'
            />

            <linearGradient
              id='SVGID_00000176732818819123589690000001004071113425261955_'
              gradientUnits='userSpaceOnUse'
              x1='16.5253'
              y1='209.4111'
              x2='716.6523'
              y2='209.4111'
            >
              <stop offset='0' style={{ stopColor: '#2C2F31' }} />
              <stop offset='0.2946' style={{ stopColor: '#232627' }} />
              <stop offset='0.7889' style={{ stopColor: '#0C0D0D' }} />
              <stop offset='1' style={{ stopColor: '#000000' }} />
            </linearGradient>
            <path
              style={{
                fill: 'url(#SVGID_00000176732818819123589690000001004071113425261955_)',
              }}
              d='M716.652,404.348V33.65
				c0,0,0.19-19.176-19.389-19.176H35.914c-19.58,0-19.389,19.176-19.389,19.176v370.697H716.652z'
            />
            <rect
              x='32.895'
              y='34.496'
              style={{ fill: 'transparent' }}
              width='667.391'
              height='351.624'
            />
            <foreignObject
              x='32.895'
              y='34.496'
              width='667.391'
              height='351.624'
            >
              {children ? children : (<p>no elements</p>)}
              <iframe
                src='https://www.subkontrakt.sk'
                title='Subkontrakt.sk'
                style={{ width: '100%', height: '100%' }}
              ></iframe>
            </foreignObject>
          </g>

          <linearGradient
            id='SVGID_00000070091428924369721910000006857558460575476921_'
            gradientUnits='userSpaceOnUse'
            x1='366.5869'
            y1='18.7183'
            x2='366.5869'
            y2='33.7614'
          >
            <stop offset='0' style={{ stopColor: '#2C2F31' }} />
            <stop offset='0.1538' style={{ stopColor: '#717374' }} />
            <stop offset='0.3365' style={{ stopColor: '#BDBEBF' }} />
            <stop offset='0.4673' style={{ stopColor: '#EDEDED' }} />
            <stop offset='0.5322' style={{ stopColor: '#FFFFFF' }} />
            <stop offset='0.999' style={{ stopColor: '#FFFFFF' }} />
          </linearGradient>
          <path
            style={{
              fill: 'url(#SVGID_00000070091428924369721910000006857558460575476921_)',
            }}
            d='M368.73,19.789
			c0,1.184-0.959,2.144-2.145,2.144c-1.182,0-2.143-0.961-2.143-2.144c0-1.182,0.961-2.143,2.143-2.143
			C367.772,17.646,368.73,18.607,368.73,19.789z'
          />
        </g>
        <g>
          <defs>
            <rect
              id='SVGID_00000177482931447406621120000005534716939917810876_'
              x='32.892'
              y='34.496'
              width='667.391'
              height='351.624'
            />
          </defs>
          <clipPath id='SVGID_00000150086213003240472440000011892529513315126401_'>
            <use
              xlinkHref='#SVGID_00000177482931447406621120000005534716939917810876_'
              style={{ overflow: 'visible' }}
            />
          </clipPath>
          <g
            style={{
              clipPath:
                'url(#SVGID_00000150086213003240472440000011892529513315126401_)',
            }}
          ></g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <linearGradient
                  id='SVGID_00000174574182833501034400000015310295086068933543_'
                  gradientUnits='userSpaceOnUse'
                  x1='-426.0776'
                  y1='-70.2619'
                  x2='-426.0776'
                  y2='504.2408'
                >
                  <stop offset='0' style={{ stopColor: '#2C2F31' }} />
                  <stop offset='0.2946' style={{ stopColor: '#232627' }} />
                  <stop offset='0.7889' style={{ stopColor: '#0C0D0D' }} />
                  <stop offset='1' style={{ stopColor: '#000000' }} />
                </linearGradient>
                <path
                  style={{
                    fill: 'url(#SVGID_00000174574182833501034400000015310295086068933543_)',
                  }}
                  d='M-291.355,409.994v-42.672l0,0
						v-81.587V124.44V22.533c0-12.586-12.323-12.467-12.323-12.467h-244.799c0,0-12.323-0.119-12.323,12.467V124.44v161.295v124.259
						c0,12.586,12.323,12.467,12.323,12.467h244.799C-303.678,422.461-291.355,422.58-291.355,409.994z'
                />
                <g>
                  <g style={{ opacity: '0.6' }}>
                    <linearGradient
                      id='SVGID_00000075135089004875159720000000100885179168707247_'
                      gradientUnits='userSpaceOnUse'
                      x1='-294.2503'
                      y1='479.8297'
                      x2='-549.7645'
                      y2='100.3061'
                    >
                      <stop
                        offset='7.772600e-04'
                        style={{ stopColor: '#5F6263' }}
                      />
                      <stop offset='0.174' style={{ stopColor: '#565859' }} />
                      <stop offset='0.4657' style={{ stopColor: '#3D3E3F' }} />
                      <stop offset='0.8376' style={{ stopColor: '#141515' }} />
                      <stop offset='1' style={{ stopColor: '#000000' }} />
                    </linearGradient>
                    <path
                      style={{
                        fill: 'url(#SVGID_00000075135089004875159720000000100885179168707247_)',
                      }}
                      d='M-558.05,406.036
								c0,12.333,12.07,12.216,12.07,12.216h44.903l206.971-137.855V157.695L-558.05,333.493V406.036z'
                    />

                    <linearGradient
                      id='SVGID_00000124148797814165345170000015965473186120580025_'
                      gradientUnits='userSpaceOnUse'
                      x1='-212.4567'
                      y1='424.6867'
                      x2='-467.9303'
                      y2='45.2233'
                    >
                      <stop
                        offset='7.772600e-04'
                        style={{ stopColor: '#5F6263' }}
                      />
                      <stop offset='0.174' style={{ stopColor: '#565859' }} />
                      <stop offset='0.4657' style={{ stopColor: '#3D3E3F' }} />
                      <stop offset='0.8376' style={{ stopColor: '#141515' }} />
                      <stop offset='1' style={{ stopColor: '#000000' }} />
                    </linearGradient>
                    <polygon
                      style={{
                        fill: 'url(#SVGID_00000124148797814165345170000015965473186120580025_)',
                      }}
                      points='-558.05,153.412 
								-558.05,181.605 -306.829,14.273 -349.151,14.273 							'
                    />
                  </g>
                </g>
                <rect
                  x='-551.388'
                  y='27.005'
                  width='250.623'
                  height='352.058'
                />
              </g>
              <path
                style={{ fill: '#FFFFFF' }}
                d='M-302.292,11.429c0,0-36.338,0.053-90.844,0.134c-27.251,0.038-59.047,0.084-93.114,0.134
					c-17.033-0.023-34.633-0.05-52.52-0.076c-2.236-0.003-4.477-0.008-6.72-0.01c-2.25-0.105-4.466,0.175-6.557,0.983
					c-2.073,0.796-3.957,2.144-5.209,3.989c-1.274,1.838-1.847,4.079-1.982,6.31c-0.015,9.044-0.029,18.126-0.043,27.208
					c-0.068,145.349-0.138,290.697-0.138,290.697s-0.068-145.349-0.136-290.697c0.006-9.087,0.012-18.174,0.018-27.228
					c0.131-2.266,0.707-4.569,2.017-6.47c1.285-1.909,3.229-3.306,5.349-4.123c2.114-0.836,4.45-1.128,6.68-1.027
					c2.243-0.005,4.484-0.01,6.72-0.01c17.886-0.028,35.486-0.053,52.52-0.076c34.066,0.048,65.862,0.096,93.114,0.134
					C-338.63,11.379-302.292,11.429-302.292,11.429z'
              />
            </g>
            <path
              style={{ fill: '#292929' }}
              d='M-414.842,15.389c0,0.614-0.499,1.116-1.113,1.116h-20.243c-0.615,0-1.115-0.502-1.115-1.116l0,0
				c0-0.614,0.5-1.116,1.115-1.116h20.243C-415.341,14.273-414.842,14.774-414.842,15.389L-414.842,15.389z'
            />
          </g>
          <g>
            <linearGradient
              id='SVGID_00000125562760170718534630000012267586593145768119_'
              gradientUnits='userSpaceOnUse'
              x1='-426.0774'
              y1='405.5038'
              x2='-426.0774'
              y2='355.0535'
            >
              <stop offset='0' style={{ stopColor: '#2C2F31' }} />
              <stop offset='0.2946' style={{ stopColor: '#232627' }} />
              <stop offset='0.7889' style={{ stopColor: '#0C0D0D' }} />
              <stop offset='1' style={{ stopColor: '#000000' }} />
            </linearGradient>
            <path
              style={{
                fill: 'url(#SVGID_00000125562760170718534630000012267586593145768119_);',
              }}
              d='M-416.193,395.301
				c0,5.458-4.426,9.883-9.885,9.883c-5.46,0-9.884-4.425-9.884-9.883c0-5.464,4.424-9.889,9.884-9.889
				C-420.619,385.412-416.193,389.837-416.193,395.301z'
            />

            <linearGradient
              id='SVGID_00000162346681933612863330000001072386918815180964_'
              gradientUnits='userSpaceOnUse'
              x1='-428.2453'
              y1='386.4125'
              x2='-424.0836'
              y2='403.4711'
            >
              <stop offset='0' style={{ stopColor: '#2C2F31' }} />
              <stop offset='0.2946' style={{ stopColor: '#232627' }} />
              <stop offset='0.7889' style={{ stopColor: '#0C0D0D' }} />
              <stop offset='1' style={{ stopColor: '#000000' }} />
            </linearGradient>
            <path
              style={{
                fill: 'url(#SVGID_00000162346681933612863330000001072386918815180964_)',
              }}
              d='M-417.017,395.301
				c0,5.002-4.056,9.056-9.061,9.056c-5.006,0-9.06-4.054-9.06-9.056c0-5.008,4.054-9.066,9.06-9.066
				C-421.073,386.234-417.017,390.293-417.017,395.301z'
            />
          </g>
        </g>
        <g>
          <defs>
            <rect
              id='SVGID_00000171683232009935198910000014235076787721771137_'
              x='-551.951'
              y='29.005'
              width='250.623'
              height='352.058'
            />
          </defs>
          <clipPath id='SVGID_00000086662682996360480330000002418560796297936049_'>
            <use
              xlinkHref='#SVGID_00000171683232009935198910000014235076787721771137_'
              style={{ overflow: 'visible' }}
            />
          </clipPath>
          <g
            style={{
              clipPath:
                'url(#SVGID_00000086662682996360480330000002418560796297936049_)',
            }}
          >
            <defs>
              <rect
                id='SVGID_00000010310282520993683560000015767058863827280800_'
                x='-552.822'
                y='27.967'
                width='667.391'
                height='351.624'
              />
            </defs>
            <clipPath id='SVGID_00000045609964659480896380000006366447208681413022_'>
              <use
                xlinkHref='#SVGID_00000010310282520993683560000015767058863827280800_'
                style={{ overflow: 'visible' }}
              />
            </clipPath>
            <g
              style={{
                clipPath:
                  'url(#SVGID_00000045609964659480896380000006366447208681413022_);',
              }}
            ></g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default MonitorMockup;
